export const ROLES = {
  ADMIN: 'admin',
  SALES: 'sales',
  MARKETING: 'marketing',
  PURCHASE: 'purchase',
}

export const ROLE_DASHBOARD_PATH = {
  [ROLES.ADMIN]: '/admin',
  [ROLES.SALES]: '/sales',
  [ROLES.MARKETING]: '/marketing',
  [ROLES.PURCHASE]: '/purchase',
}

export const ROLE_LABEL = {
  [ROLES.ADMIN]: 'Admin Dashboard',
  [ROLES.SALES]: 'Sales Dashboard',
  [ROLES.MARKETING]: 'Marketing Dashboard',
  [ROLES.PURCHASE]: 'Purchase Dashboard',
}

export const ROLE_SHORT_LABEL = {
  [ROLES.ADMIN]: 'Admin',
  [ROLES.SALES]: 'Sales',
  [ROLES.MARKETING]: 'Marketing',
  [ROLES.PURCHASE]: 'Purchase',
}

export const ROLE_ME_PATH = {
  [ROLES.ADMIN]: '/admin/me',
  [ROLES.SALES]: '/sales/me',
  [ROLES.MARKETING]: '/marketing/me',
  [ROLES.PURCHASE]: '/purchase/me',
}

export function getDashboardPathForRole(role) {
  return ROLE_DASHBOARD_PATH[role] || '/login'
}

export function getRoleLabel(role) {
  return ROLE_LABEL[role] || 'Dashboard'
}

export function getRoleShortLabel(role) {
  return ROLE_SHORT_LABEL[role] || 'User'
}

export function isValidRole(role) {
  return Object.values(ROLES).includes(role)
}
